
<div id="mainArea">
    <router-outlet></router-outlet>     
</div>
